import React from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;

export const EasedKeyframeIcon: React.FC<Props> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path className="pointer-events-none" d="M3.05029 1.64001H12.9498L9.58614 8.00064L12.9498 14.364H3.05029L6.41389 8.00064L3.05029 1.64001Z" />
  </svg>
);
